import { render } from "./project-loader.vue?vue&type=template&id=3b984a3a&scoped=true"
import script from "./project-loader.vue?vue&type=script&lang=js"
export * from "./project-loader.vue?vue&type=script&lang=js"

import "./project-loader.vue?vue&type=style&index=0&id=3b984a3a&lang=scss"
import "./project-loader.vue?vue&type=style&index=1&id=3b984a3a&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b984a3a"]])

export default __exports__